function loadQuizModalRP(htmlBlockIdSelectorForResults) {
    //if (typeof (globalStore.questionaire_retainportfolio) === 'undefined') {
        globalStore.questionaire_retainportfolio = docObject.getDOCObject().assets.retainportfolioProfile.questionnaire;
        quizRP = new nnip.classes.Quiz(globalStore.questionaire_retainportfolio);
        globalStore.id_of_html_element_to_post_results_to = htmlBlockIdSelectorForResults
    //}
    $('#quizModal').modal({
        backdrop : 'static',
        keyboard : false
    });
}


function getRiskProfileRetainPortfolio(accounts, riskProfileData, step) {
    if(typeof(accounts) !== "undefined"){
        riskProfileData.isMultiple = (accounts.length > 1) ? true : false;
        getRpfQuestionaireAssets(riskProfileData, step);
    }
}


function getRpfQuestionaireAssets(profileData, step) {
    if (typeof (docObject.getDOCObject().assets.retainportfolioProfile) === 'undefined') {
        $.getJSON("/web/nniprestserviceservlet/riskProfile?accountId=" + profileData.selectedAccountNumber, function(questionaire) {

            docObject.setRpfQuestionaireAssets({assets : questionaire.retainPortfolioAssets,
                questionnaire: questionaire.retainPortfolioQuestionnaire});

            profileData.assets = questionaire.retainPortfolioAssets;
            profileData.languagelabels = jsLanguageLabel;
            var parsedSelectedProfile = globalStore.selectedRiskProfile.toLowerCase()
            
            //Add the selected riskporfile to the profileData to be used in html template
            if(flowConfig.type === 'profile'){
                switch(parsedSelectedProfile) {
                    case "defensive": 
                        profileData.selectedRiskprofileLabel = profileData.languagelabels.txtInvestmentProfile_DEF;
                        profileData.selectedRiskprofile = "DEF"
                    break;
                    case "defensive_variable": 
                        profileData.selectedRiskprofileLabel = profileData.languagelabels.txtProfile_DEFENSIVE_VARIABLE;
                        profileData.selectedRiskprofile = "DEF_VAR"
                    break;
                    case "offensive":
                        profileData.selectedRiskprofileLabel = profileData.languagelabels.txtInvestmentProfile_OFF;
                        profileData.selectedRiskprofile = "OFF"
                    break;
                    case "offensive_variable":
                        profileData.selectedRiskprofileLabel = profileData.languagelabels.txtProfile_OFFENSIVE_VARIABLE;
                        profileData.selectedRiskprofile = "OFF_VAR"
                    break;
                    case "neutral":
                        profileData.selectedRiskprofileLabel = profileData.languagelabels.txtInvestmentProfile_NEU;
                        profileData.selectedRiskprofile = "NEU"
                    break;
                    case "neutral_variable":
                        profileData.selectedRiskprofileLabel = profileData.languagelabels.txtProfile_NEUTRAL_VARIABLE;
                        profileData.selectedRiskprofile = "NEU_VAR"
                    break;
                    default:
                        profileData.selectedRiskprofile = "Undefined_profile: " + globalStore.selectedRiskProfile
                    break;
                }
            } else{
                switch(parsedSelectedProfile) {
                    case "defensive": 
                        profileData.selectedRiskprofileLabel = profileData.languagelabels.txtProfile_DEFENSIVE;
                        profileData.selectedRiskprofile = "DEF"
                    break;
                    case "defensive_variable": 
                        profileData.selectedRiskprofileLabel = profileData.languagelabels.txtProfile_DEFENSIVE_VARIABLE;
                        profileData.selectedRiskprofile = "DEF_VAR"
                    break;
                    case "offensive":
                        profileData.selectedRiskprofileLabel = profileData.languagelabels.txtProfile_OFFENSIVE;
                        profileData.selectedRiskprofile = "OFF"
                    break;
                    case "offensive_variable":
                        profileData.selectedRiskprofileLabel = profileData.languagelabels.txtProfile_OFFENSIVE_VARIABLE;
                        profileData.selectedRiskprofile = "OFF_VAR"
                    break;
                    case "neutral":
                        profileData.selectedRiskprofileLabel = profileData.languagelabels.txtProfile_NEUTRAL;
                        profileData.selectedRiskprofile = "NEU"
                    break;
                    case "neutral_variable":
                        profileData.selectedRiskprofileLabel = profileData.languagelabels.txtProfile_NEUTRAL_VARIABLE;
                        profileData.selectedRiskprofile = "NEU_VAR"
                    break;
                    default:
                        profileData.selectedRiskprofile = "Undefined_profile: " + globalStore.selectedRiskProfile
                    break;
                }

            }
            /*
             * Add translated labels in docobject for proper rendering in
             * mustache templates
             */
            _.each(profileData.assets, function(asset, index) {
                asset.txtLabel = jsLanguageLabel[asset.name];
                asset.rank = index;
            });

            // setTemplate Params:
            // 1. id of the html template
            // 2. The rendered mustache template from the global store
            // 3. Partial data  (or null)
            // 4. Partial template (or null)

            wizard.setTemplate('#retainPortfolioProfile', globalStore[rpProfileTemplate], profileData, globalStore[docAssetPartial]);
        }).fail(function(errMsg) {
            setError(errMsg.status, errMsg.responseText);
        }).always(function() {
            wizard.validateStep(step);
        });
    }
}